module.exports = __webpack_public_path__ + "static/kallelse-arsstamma-2024-06-27-c326f36f258f65f79c46c775d63ef538.pdf";